export default "__VITE_ASSET__aoePWx65__"